var _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLucasWorkout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 240 400",
    shapeRendering: "crispEdges",
    id: "svg--lucas",
    className: "svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "lucas__head"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--brown",
    points: "90,10 150,10, 150,20 160,20 160,40 100,40 100,50 80,50 80,60 70,60 70,30 80,30 80,20 90,20"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pixel--light-brown",
    x: 160,
    y: 30,
    width: 10,
    height: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--skin",
    points: "100,40 170,40 170,60 180,60 180,80 160,80 160,100 150,100 150,90 90,90 90,100 80,100 80,80 60,80 60,60 80,60 80,50 100,50"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pixel--black",
    x: 90,
    y: 60,
    width: 10,
    height: 20
  }), /*#__PURE__*/React.createElement("rect", {
    className: "pixel--black",
    x: 140,
    y: 60,
    width: 10,
    height: 20
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--stubble",
    points: "70,80 80,80 80,100 100,100 100,90 90,90 90,110 70,110"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--stubble",
    points: "140,90 150,90 150,110 170,110, 170,80 160,80 160,100 140,100"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--light-brown",
    points: "100,100 100,90 140,90 140,100 90,100 90,110 80,110 80,130 160,130 160,110 150,110 150,100 140,100"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--white",
    points: "100,100 140,100 140,110 130,110 130,120 110,120 110,110 100,110"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--stubble",
    points: "100,110 110,110 110,120 100,120"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--stubble",
    points: "130,110 140,110 140,120 130,120"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--brown",
    points: "70,110 80,110 80,120 70,120"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--brown",
    points: "160,110 170,110 170,120 160,120"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--brown",
    points: "80,130 160,130 160,140 80,140"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--dark-brown",
    points: "70,120 80,120 80,150 100,150 100,160 140,160 140,150 160,150 160,120 170,120 170,140 70,140"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--darkest-brown",
    points: "70,140 70,150 100,150 100,160 140,160 140,150 170,150 170,140 160,140 160,160 150,160 150,170 90,170 90,160 80,160 80,140"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--blue",
    points: "70,30 170,30 170,50 70,50"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "lucas__torso"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--blue",
    points: "70,160 90,160 90,170 150,170 150,160 170,160 170,170 180,170 180,190 160,190 160,260 80,260 80,190 60,190 60,170 70,170"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "lucas__legs"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--gray",
    points: "80,260 160,260 160,320 130,320 130,290 110,290 110,320 80,320"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--skin",
    points: "160,320 160,380 140,380 140,320"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--skin",
    points: "100,320 100,380 80,380 80,320"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "lucas__shoes"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--leather",
    points: "60,380 100,380 100,390 60,390"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--leather",
    points: "140,380 180,380 180,390 140,390"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--dark-leather",
    points: "60,390 100,390 100,400 60,400"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "pixel--dark-leather",
    points: "140,390 180,390 180,400 140,400"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "lucas__arms"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "lucas__arm--right pixel--skin",
    points: "60,190 80,190 80,240 10,240 10,210 20,210 20,200 30,200 30,220 60,220"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lucas__arm--left pixel--skin",
    points: "160,190 180,190 180,260 190,260 190,280 180,280 180,290 160,290"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLucasWorkout);
export default __webpack_public_path__ + "static/media/lucas-workout.0a769e25d50cbe18b6d9ca8285f9f4af.svg";
export { ForwardRef as ReactComponent };